<template>
  <div class="text-block" :style="myBlockProps.getStyles(visible)">
    <span :style="myTextProps.getStyles()">{{ myText.getText(selectedLanguage) }}</span>
  </div>
</template>

<script>
import Block from './Block.vue';

import { MultiLanguageText, TextProps } from '../models';

export default {
  name: 'text-block',
  extends: Block,
  props: {
    textProps: {
      type: Object,
      required: true,
      default: () => {
      }
    },
    text: { type: Object, required: true, default: () => null }
  },
  computed: {
    myTextProps() {
      return new TextProps(this.textProps);
    },
    myText() {
      return new MultiLanguageText(this.text);
    },
  }
};
</script>
